
import { messages, validations } from "./validations";
import Form from "./Form";

export default class Input {

    /**
     * @type {HTMLElement}
     */
    element;

    /**
     * @type {HTMLElement}
     */
    inputElement;

    /**
     * @type {HTMLElement}
     */
    errorElement;

    /**
     * @type {Form}
     */
    form;

    max;
    min;

    _isValid = true;

    _value;

    get isValid() {
        return this._isValid;
    }

    set isValid(value) {
        this._isValid = !!value;
        this.onValidityChange();
    }

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.validate();
        this.form.onChange();
    }

    validations = [];

    /**
     * 
     * @param {HTMLElement} element 
     * @param {Form} form 
     * @returns 
     */
    constructor(element, form) {
        this.element = element;
        this.inputElement = this.element?.querySelector('input');
        this.form = form;

        if (!this.inputElement || this.inputElement.type === 'radio') {
            return;
        }

        this._value = this.inputElement.value;

        this.name = this.inputElement.name;
        this.max = this.inputElement.max.length ? Number(this.inputElement.max) : undefined;
        this.min = this.inputElement.min.length ? Number(this.inputElement.min) : undefined;
        if (this.inputElement.required) {
            this.validations.push('required');
        }

        if (this.inputElement.type === 'email') {
            this.validations.push('email');
        }

        if (this.inputElement.type === 'tel') {
            this.validations.push('tel');
        }

        if (this.inputElement.inputMode === 'numeric') {
            this.validations.push('number');
        }

        if ( this.min !== undefined ) {
            this.validations.push('number_min');
        }

        if ( this.max !== undefined ) {
            this.validations.push('number_max');
        }

        this.addListeners();
    }

    addListeners() {
        this.inputElement.addEventListener('input', () => {
            this.value = this.inputElement.value;
        });
    }

    validate() {
        const results = [];

        this.validations.forEach(validationName => {
            if (validations[validationName]) {
                results.push(validations[validationName](this.value, this));
            }
        });

        const firstError = results.find(el => !el.valid);

        if (!firstError) {
            this.removeError();
            this.isValid = true;
        } else {
            this.isValid = false;
            this.addError(firstError.code);
        }

        return this.isValid;
    }

    onValidityChange() {
        //console.log(this.isValid ? 'valid' : 'invalid');
    }

    addError(code) {
        let message = messages[code] ?? code;

        if (code === 'less_than_min') {
            message = message.replace('*', this.min);
        }

        if (code === 'more_than_max') {
            message = message.replace('*', this.max);
        }

        this.element.classList.add('error');
        this.addErrorElement();
        
        this.errorElement.innerHTML = message;
    }

    removeError() {
        this.element.classList.remove('error');

        if (!this.errorElement) {
            return;
        }
        
        this.errorElement.classList.remove('show');
    }

    addErrorElement() {

        if (!this.errorElement) {
            this.errorElement = document.createElement('div');
            this.errorElement.classList.add('error-element');
            this.element.after(this.errorElement);
        }

        setTimeout(() => {
            this.errorElement.classList.add('show');
        }, 30);
    }

    reset() {
        if (this.inputElement.getAttribute("name") === 'result_type' || this.inputElement.getAttribute("name") === 'paged') {
            return;
        }
        
        this.value = '';
        this.removeError();

        if (this.inputElement) {
            this.inputElement.value = '';
        }
    }
}
